import React from 'react'
import ReactDOM from 'react-dom'
import ClientApp from './client-app'

ReactDOM.hydrate(<ClientApp isHmr={false} />, document.getElementById('root'))
